export default __webpack_public_path__ + "static/media/2021 knife block B top.a6ccd5f6.png";